<template>
  <div class="ms-power-bi-summary">
    <div class="_item">
      <div class="_label">
        {{ $t('msPowerBiSummary.group') }}:
      </div>
      <div class="_content">
        {{ groupName }}
      </div>
    </div>
    <div class="_item">
      <div class="_label">
        {{ $t('msPowerBiSummary.dataset') }}:
      </div>
      <div class="_content">
        {{ query.datasetName }}
      </div>
    </div>
    <div class="_item">
      <div class="_label">
        {{ $t('msPowerBiSummary.dax') }}:
      </div>
      <m-tooltip
        class="_content"
        placement="bottom"
        :disabled="!isTruncated"
        :mouse-enter-delay=".5"
      >
        <template #title>
          {{ query.dax }}
        </template>
        <div
          ref="daxRef"
          class="_content"
        >
          {{ query.dax }}
        </div>
      </m-tooltip>
    </div>
  </div>
</template>

<script setup>
import useElementsTruncate from 'shared/composables/element-truncate';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  query: {
    type: Object,
    required: true,
  },
});
const daxRef = ref(null);
const { isTruncated } = useElementsTruncate([daxRef]);
const groupName = computed(() => {
  if (props.query.groupId === 'self') {
    return t('msPowerBIForm.selfGroup');
  }
  return props.query.groupName;
});
</script>

<style scoped lang="scss" type="text/scss">
  .ms-power-bi-summary {
    ._item {
      display: flex;

      ._label {
        flex: 0 0 8.1rem;
        color: $font-color-secondary;
      }

      ._content {
        white-space: nowrap;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>
